// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'subscriptions.page.title': 'Subscriptions',
    'subscription.page.current': 'Current',

    'subscription.button.upgrade': 'Upgrade',
};
